<template>
  <div v-if="number" class="quote-reference">
    <span class="quote-number">D{{ format(number) }}</span>
    <span v-if="orderNumber" class="order-number" title="Dossier">C{{ format(orderNumber) }}</span>
  </div>
</template>

<script>
export default {
  name: 'QuoteNumber',
  props: {
    number: {type: Number, default: undefined},
    orderNumber: {type: Number, default: undefined},
  },
  methods: {
    format(number) {
      return number.toString().padStart(4, '0');
    },
  },
};
</script>

<style lang="stylus" scoped>
.quote-reference
  display flex
  align-items baseline
  gap 6px

.quote-number
  font-weight 700

.order-number
  font-size 0.85em
  color #8a8f96
</style>
